import { TEAMS_PATH } from "features/scope/types/ScopePathParameter";

export const teamsRoute = `/:region/${TEAMS_PATH}`;
